import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../../features/site/siteSlice'

import { serviceMap } from '../../../../utils/common'
import FacebookInsightsClaimCard from '../../../Admin/ServiceTypes/FacebookInsights'

import ServiceCardBase from '../../ServiceCardBase'

function FacebookInsights({ onSave, onCancel}){
    const dispatch = useDispatch()
    
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)

    const site = model?.sites[model.siteActiveIdx]

    const { siteForm } = model

    const editSite = async() => {
        await dispatch(appendModel({
            siteForm: {
                ...siteForm,
                attr: {
                    ...siteForm.attr,
                    accounts: {
                        ...(siteForm?.attr?.accounts ?? {}),
                        fbPage: undefined
                    }
                }
            }
        }))
    }


    return <ServiceCardBase 
        title="Facebook Insights" 
        header="Facebook Insights" 
        description=" "
        image={serviceMap.fbPage.img}>
            <FacebookInsightsClaimCard design="onboarding" />
            <div class="d-flex flex-row-reverse justify-content-between">
                <div>
                    {siteForm?.attr?.accounts?.fbPage && <button className="mr-3 btn btn-lg btn-outline-primary" onClick={() => editSite()}>
                        Edit
                    </button>}
                    {siteForm?.attr?.accounts?.fbPage && oauthTokens?.fbPage ? <button id="saveFbPage" className="btn btn-lg btn-primary" onClick={async() => {
                        await onSave("fbPage")
                    }}>Save</button> : <div></div>}
                </div>
                {(!siteForm?.attr?.accounts?.fbPage || localStorage.getItem("fbPageSelection") === null) && <button id="fbPageClaimLater" className="btn btn-lg btn-link" onClick={() =>onCancel("fbPage")}>
                    Claim Later
                </button>}
            </div>
    </ServiceCardBase>
}

export default FacebookInsights